export default [


    {
        path: '',
        name: 'adminDashboard',
        component: () => import('@/views/admin/dashboard/AdminDashboard.vue'),
    },
    {
        path: 'empresas',
        component: () => import('@/views/admin/empresas/EmpresasPage.vue'),
        props: true,

        children: [
            {
                path: '',
                name: 'empresasList',
                component: () => import('@/views/admin/empresas/EmpresasList.vue'),

            },
            {
                path: 'registrar',
                name: 'registrarEmpresa',
                component: () => import('@/views/admin/empresas/EmpresaRegister.vue'),

            },
            {
                path: 'editar',
                name: 'empresaEditar',
                component: () => import('@/views/admin/empresas/EmpresaUpdate.vue'),

            },
        ],
    },

    {
        path: 'empresa/:uuid_empresa',

        component: () => import('@/views/admin/EmpresaLayout.vue'),
        children: [
            {
                path: '',
                name: 'empresaDatosGenerales',
                component: () => import('@/views/admin/empresas/EmpresaDetallesGenerales.vue'),
            },

            {
                path: 'editar',
                name: 'empresaEditar',
                component: () => import('@/views/admin/empresas/EmpresaUpdate.vue'),
            },

            {
                path: 'configuracion',
                name: 'empresaConfiguracion',
                component: () => import('@/views/admin/empresas/EmpresaConfiguracion.vue'),
            },

            {
                path: 'duenos',
                name: 'empresaDueños',
                component: () => import('@/views/admin/empresas/EmpresaDueñosHome.vue'),
            },

            {
                path: 'productos',
                name: 'admin.productosHome',
                component: () => import('@/views/admin/productos/ProductosEmpresaHome.vue'),
                redirect: { name: 'admin.productosListado' }, // 👈 redirección
                children: [
                    {
                        path: '',

                        name: 'admin.productosListado',
                        component: () => import('@/views/admin/productos/ProductosEmpresaListado.vue'),

                    },
                    {
                        path: 'categorias',

                        name: 'admin.productosCategorias',
                        component: () => import('@//views/admin/productos/categorias/ProductosEmpresaCategorias.vue'),
                        redirect: { name: 'admin.productosCategorias.unificar' }, // 👈 redirección

                        children: [
                            {
                                path: '',
                                name: 'admin.productosCategorias.unificar',
                                component: () => import('@/views/admin/productos/categorias/ProductoCategoriasTree.vue')

                            }
                        ]


                    },
                    {
                        path: 'registrar',
                        name: 'admin.productosRegistrarHome',

                        component: () => import('@/views/admin/productos/registrar/ProductoEmpresaRegistrarHome.vue'),
                        children: [
                            {
                                path: '',

                                name: 'admin.productosRegistrar.tipoRegistro',

                                component: () => import('@/views/admin/productos/registrar/ProductoEmpresaRegistrarTipo.vue'),

                            },
                            {
                                path: 'buscar',
                                name: 'admin.productosRegistrar.buscar',

                                component: () => import('@/views/admin/productos/registrar/ProductoEmpresaRegistrarBuscar.vue'),

                            },

                        ]

                    },
                ]

            },
            {
                path: 'sucursales',
                name: 'admin.sucursalesHome',
                component: () => import('@/views/admin/sucursales/SucursalesEmpresaHome.vue'),
            },
            {
                path: 'sucursales/registrar',
                name: 'admin.sucursalRegistrar',
                component: () => import('@/views/admin/sucursales/SucursalEmpresaRegistrar.vue'),

            },
            {
                path: 'contabilidad',
                name: 'empresaContabilidad',
                component: () => import('@/components/empresa/EmpresaContabilidad.vue'),
            },
            {
                path: 'categorias',
                name: 'empresaCategorias',
                component: () => import('@/components/empresa/EmpresaCategorias.vue'),
            },
            {
                path: 'proveedores',
                name: 'proveedoresEmpresa',
                component: () => import('@/views/proveedores/ProveedoresEmpresaHome.vue'),
            },

        ],

        meta: { requiresAuth: true, requireArqueoCaja: false, requireCaja: false, requireSucursal: false }


    },
    {
        path: 'empresa/:uuid_empresa/productos/:id_producto',
        name: 'productoEmpresaDetalle',
        component: () => import('@/views/admin/productos/layout/ProductoEmpresaLayout.vue'),
        redirect: { name: 'gestionProductosEmpresaItemDetalle' }, // 👈 redirección
        children: [
            {
                path: 'detalles',
                name: 'gestionProductosEmpresaItemDetalle',
                component: () => import('@/views/producto/gestion/ProductosGestionHomeItemActualizar.vue'),
            },
            {
                path: 'sucursales',
                name: 'productosEnSucursales',
                component: () => import('@/views/producto/gestion/ProductosGestionHomeSucursales.vue')
            },
        ],
        meta: { requiresAuth: true, requireArqueoCaja: false, requireCaja: false, requireSucursal: false },
    },

    {
        path: 'empresa/:uuid_empresa/sucursales/:uuid_sucursal',
        name: 'admin.sucursalDetail',

        component: () => import('@/views/admin/sucursales/SucursalDetail.vue'),
        meta: { requiresAuth: true, requireArqueoCaja: false, requireCaja: false, requireSucursal: true, requireSucursalSeleccionada: true },

        children: [
            {
                path: '',
                name: 'sucursalDatosGenerales',
                component: () => import('@/views/admin/sucursales/SucursalDetallesGenerales.vue'),
                meta: { requiresAuth: true, requireArqueoCaja: false, requireCaja: false, requireSucursal: true, requireSucursalSeleccionada: true }
            },
            {
                path: 'empleados',
                name: 'admin.sucursalesEmpleados',
                component: () => import('@/views/admin/sucursales/empleados/EmpleadosSucursalView.vue'),
                meta: { requiresAuth: true, requireArqueoCaja: false, requireCaja: false, requireSucursal: true, requireSucursalSeleccionada: true }
            },
            {
                path: 'productos',
                name: 'sucursalProductos',
                component: () => import('@/views/admin/sucursales/productos/SucursalProductosHome.vue'),
                meta: { requiresAuth: true, requireArqueoCaja: false, requireCaja: false, requireSucursal: true, requireSucursalSeleccionada: true },
                redirect: { name: 'sucursalProductosLista' }, // 👈 redirección

                children: [

                    {
                        path: '',
                        name: 'sucursalProductosLista',
                        component: () => import('@/views/admin/sucursales/productos/SucursalProductosList.vue'),
                        meta: { requiresAuth: true, requireArqueoCaja: false, requireCaja: false, requireSucursal: true, requireSucursalSeleccionada: true }
                    },
                    {
                        path: 'inventario',
                        name: 'sucursalProductosInventario',
                        component: () => import('@/views/admin/sucursales/productos/SucursalProductosInventario.vue'),
                        meta: { requiresAuth: true, requireArqueoCaja: false, requireCaja: false, requireSucursal: true, requireSucursalSeleccionada: true }
                    },

                ]
            },
            {
                path: 'empleados/registrar',
                name: 'sucursalEmpleadosRegistrar',
                component: () => import('@/components/sucursal/SucursalEmpleadosRegistrar.vue'),
                meta: { requiresAuth: true, requireArqueoCaja: false, requireCaja: false, requireSucursal: true, requireSucursalSeleccionada: true }
            },
            {
                path: 'editar',
                name: 'sucursalEditar',
                component: () => import('@/views/sucursal/sucursal.editar.vue'),
                meta: { requiresAuth: true, requireArqueoCaja: false, requireCaja: false, requireSucursal: true, requireSucursalSeleccionada: true }
            },
            {
                path: 'duenos',
                name: 'sucursalDueño',
                component: () => import('@/components/sucursal/SucursalDueñoList.vue'),
                meta: { requiresAuth: true, requireArqueoCaja: false, requireCaja: false, requireSucursal: true, requireSucursalSeleccionada: true }
            },
            {
                path: 'duenos/registrar',
                name: 'sucursalDueñoRegistrar',
                component: () => import('@/components/sucursal/SucursalEmpleadosRegistrar.vue'),
                meta: { requiresAuth: true, requireArqueoCaja: false, requireCaja: false, requireSucursal: true, requireSucursalSeleccionada: true }

            },
            {
                path: 'contabilidad',
                name: 'admin.sucursalContabilidad',
                component: () => import(/* webpackChunkName: "about" */ '@/views/admin/sucursales/contabilidad/ContabilidadHome.vue'),
                meta: { requiresAuth: true, requireArqueoCaja: false, requireCaja: false, requireSucursal: true, requireSucursalSeleccionada: true },

                children: [
                    {
                        path: 'formas-de-pago',
                        name: 'contabilidadFormasDePago',
                        component: () => import(/* webpackChunkName: "about" */ '@/views/contabilidad/ContabilidadFormasDePago.vue'),
                        meta: { requiresAuth: true, requireArqueoCaja: false, requireCaja: false, requireSucursal: true, requireSucursalSeleccionada: true }
                    },
                    {
                        path: 'formas-de-pago',
                        name: 'contabilidadFormasDePagoRegistrar',
                        component: () => import(/* webpackChunkName: "about" */ '@/views/contabilidad/ContabilidadFormasDePagoRegistrar.vue'),
                        meta: { requiresAuth: true, requireArqueoCaja: false, requireCaja: false, requireSucursal: true, requireSucursalSeleccionada: true }
                    },
                    {
                        path: 'reportes',
                        name: 'admin.contabilidadReportes',
                        component: () => import(/* webpackChunkName: "about" */ '@/views/admin/sucursales/contabilidad/ContabilidadReportesHome.vue'),
                        meta: { requiresAuth: true, requireArqueoCaja: false, requireCaja: false, requireSucursal: true, requireSucursalSeleccionada: true }

                    },

                    {
                        path: 'cuentas-por-defecto',
                        name: 'contabilidadCuentasDefecto',
                        component: () => import(/* webpackChunkName: "about" */ '@/views/contabilidad/ContabilidadCuentasDefecto.vue'),
                        meta: { requiresAuth: true, requireArqueoCaja: false, requireCaja: false, requireSucursal: true, requireSucursalSeleccionada: true }
                    },

                    {
                        path: 'plancuentas',
                        name: 'admin.sucursalContabilidadPlanDeCuentas',
                        component: () => import(/* webpackChunkName: "about" */ '@/views/contabilidad/ContabilidadPlanDeCuentas.vue'),
                        meta: { requiresAuth: true, requireArqueoCaja: false, requireCaja: false, requireSucursal: true, requireSucursalSeleccionada: true }
                    },

                    {
                        path: 'rubros',
                        name: 'admin.sucursalContabilidadRubros',
                        component: () => import(/* webpackChunkName: "about" */ '@/views/admin/sucursales/contabilidad/ContabilidadRubrosHome.vue'),
                        meta: { requiresAuth: true, requireArqueoCaja: false, requireCaja: false, requireSucursal: true, requireSucursalSeleccionada: true }

                    },
                    {
                        path: 'asientos',
                        name: 'admin.sucursalContabilidadAsientos',
                        component: () => import(/* webpackChunkName: "about" */ '@/views/admin/sucursales/contabilidad/ContabilidadAsientoHome.vue'),
                        meta: { requiresAuth: true, requireArqueoCaja: false, requireCaja: false, requireSucursal: true, requireSucursalSeleccionada: true }
                    },

                    {
                        path: 'rubroventa',
                        name: 'rubroVenta',
                        component: () => import(/* webpackChunkName: "about" */ '@/views/contabilidad/ContabilidadRubroVenta.vue'),
                        meta: { requiresAuth: true, requireArqueoCaja: false, requireCaja: false, requireSucursal: true, requireSucursalSeleccionada: true }
                    },
                    {
                        path: 'rubroventa/registrar',
                        name: 'rubroVentaRegistrar',
                        component: () => import(/* webpackChunkName: "about" */ '@/views/contabilidad/ContabilidadRubroVentaRegistrar.vue'),
                        meta: { requiresAuth: true, requireArqueoCaja: false, requireCaja: false, requireSucursal: true, requireSucursalSeleccionada: true }

                    },
                    {
                        path: 'rubroventa/editar',
                        name: 'rubroVentaUpdate',
                        component: () => import(/* webpackChunkName: "about" */ '@/views/contabilidad/ContabilidadRubroVentaUpdate.vue'),
                        meta: { requiresAuth: true, requireArqueoCaja: false, requireCaja: false, requireSucursal: true, requireSucursalSeleccionada: true }
                    },
                    {
                        path: 'rubrocompra',
                        name: 'rubroCompra',
                        component: () => import(/* webpackChunkName: "about" */ '@/views/contabilidad/ContabilidadRubroCompra.vue'),
                        meta: { requiresAuth: true, requireArqueoCaja: false, requireCaja: false, requireSucursal: true, requireSucursalSeleccionada: true }
                    },
                    {
                        path: 'asiento/mantenimiento',
                        name: 'asientoMantenimiento',
                        component: () => import(/* webpackChunkName: "about" */ '@/views/contabilidad/asiento/manenimiento/MantenimientoAsientoView.vue'),

                        meta: { requiresAuth: true, requireArqueoCaja: false, requireCaja: false, requireSucursal: true, requireSucursalSeleccionada: true }

                    },
                    {
                        path: 'asiento/mantenimiento/registrar',
                        name: 'asientoMantenimientoRegistrar',
                        component: () => import(/* webpackChunkName: "about" */ '@/views/contabilidad/asiento/manenimiento/MantenimientoAsientoRegistrarView.vue'),
                    },
                    {
                        path: 'asiento/mantenimiento/editar/:numero?',
                        name: 'asientoMantenimientoUpdate',
                        component: () => import(/* webpackChunkName: "about" */ '@/views/contabilidad/asiento/manenimiento/MantenimientoAsientoUpdateView.vue'),

                        meta: { requiresAuth: true, requireArqueoCaja: false, requireCaja: false, requireSucursal: true, requireSucursalSeleccionada: true }

                    },
                    {
                        path: 'asientotipo',
                        name: 'asientoTipo',
                        component: () => import(/* webpackChunkName: "about" */ '@/views/contabilidad/asiento/asientotipo/AsientoTipoView.vue'),

                        meta: { requiresAuth: true, requireArqueoCaja: false, requireCaja: false, requireSucursal: true, requireSucursalSeleccionada: true }

                    },
                    {
                        path: 'asientotipo/registrar',
                        name: 'asientoTipoRegistrar',
                        component: () => import(/* webpackChunkName: "about" */ '@/views/contabilidad/asiento/asientotipo/AsientoTipoRegistrarView.vue'),
                        meta: { requiresAuth: true, requireArqueoCaja: false, requireCaja: false, requireSucursal: true, requireSucursalSeleccionada: true }
                    },
                    {
                        path: 'asientotipo/editar',
                        name: 'asientoTipoUpdate',
                        component: () => import(/* webpackChunkName: "about" */ '@/views/contabilidad/asiento/asientotipo/AsientoTipoUpdateView.vue'),
                        meta: { requiresAuth: true, requireArqueoCaja: false, requireCaja: false, requireSucursal: true, requireSucursalSeleccionada: true }

                    },
                    {
                        path: 'rubrocompra/registrar',
                        name: 'rubroCompraRegistrar',
                        component: () => import(/* webpackChunkName: "about" */ '@/views/contabilidad/ContabilidadRubroCompraRegistrar.vue'),

                        meta: { requiresAuth: true, requireArqueoCaja: false, requireCaja: false, requireSucursal: true, requireSucursalSeleccionada: true }

                    },
                    {
                        path: 'rubrocompra/editar',
                        name: 'rubroCompraUpdate',
                        component: () => import(/* webpackChunkName: "about" */ '@/views/contabilidad/ContabilidadRubroCompraUpdate.vue'),

                        meta: { requiresAuth: true, requireArqueoCaja: false, requireCaja: false, requireSucursal: true, requireSucursalSeleccionada: true }

                    },
                    {
                        path: 'contabilidad',
                        name: 'admin.sucursalContabilidadValidar',
                        component: () => import(/* webpackChunkName: "about" */ '@/components/sucursal/contabilidad/SucursalContabilidad.vue'),
                        meta: { requiresAuth: true, requireArqueoCaja: false, requireCaja: false, requireSucursal: true, requireSucursalSeleccionada: true }

                    },

                ],


                meta: { requiresAuth: true, requireArqueoCaja: false, requireCaja: false, requireSucursal: true, requireSucursalSeleccionada: true }

            },




        ],
    },
    {
        path: 'empresa/:uuid_empresa/sucursales/:uuid_sucursal/productos/:id_producto_sucursal',
        name: 'gestionProductosEmpresaItemSucursales',

        component: () => import(/* webpackChunkName: "about" */ '@/views/admin/sucursales/productos/SucursalProductosItemLayout.vue'),
        meta: { requiresAuth: true, requireArqueoCaja: false, requireCaja: false, requireSucursal: true, requireSucursalSeleccionada: true },
        redirect: { name: 'editProductoSucursal' }, // 👈 redirección

        children: [

            {
                path: 'edit',
                name: 'editProductoSucursal',

                component: () => import(/* webpackChunkName: "about" */ '@/views/producto/actualizar/ProductoSucursalUpdate.vue'),
                meta: { requiresAuth: true, requireArqueoCaja: false, requireCaja: false, requireSucursal: true, requireSucursalSeleccionada: true }

            },
            {
                path: 'historial',
                name: 'productoSucursalHistorial',
                component: () => import('@/views/sucursal/productos/SucursalProductoHistorial.vue')

            },
            {
                path: 'inventario',
                name: 'productoSucursalInventarioDetail',
                redirect: { name: 'productoSucursalInventarioDetailStock' }, // 👈 redirección

                component: () => import(/* webpackChunkName: "about" */ '@/views/sucursal/productos/SucursalProductoInventario.vue'),
                children: [
                    {
                        path: 'stock',
                        name: 'productoSucursalInventarioDetailStock',
                        component: () => import(/* webpackChunkName: "about" */ '@/views/sucursal/productos/SucursalProductoInventarioEdit.vue'),
                    },
                    {
                        path: 'movimientos',
                        name: 'productoSucursalInventarioDetailMovimientos',
                        component: () => import(/* webpackChunkName: "about" */ '@/views/sucursal/productos/SucursalProductoInventarioMovimientos.vue'),
                    },
                ]


            },

        ]
    },

    {
        path: 'suscripciones',
        component: () => import('@/views/admin/suscripciones/SuscripcionesHome.vue'),
        children: [
            {
                path: '',
                name: 'admin.suscripciones.lista',
                component: () => import('@/views/admin/suscripciones/SuscripcionesLista.vue'),
            },
            {
                path: 'planes',
                name: 'admin.suscripciones.planes',
                component: () => import('@/views/admin/suscripciones/PlanesLista.vue'),
            },
            {
                path: 'modulos',
                name: 'admin.suscripciones.modulos',
                component: () => import('@/views/admin/suscripciones/ModulosLista.vue'),
            },
            {
                path: 'facturacion',
                name: 'admin.suscripciones.facturacion',
                component: () => import('@/views/admin/suscripciones/facturacion/FacturacionEmpresas.vue'),
            },
            {
                path: 'facturacion/empresa/:empresaId',
                name: 'admin.suscripciones.facturacion.empresa',
                component: () => import('@/views/admin/suscripciones/facturacion/FacturacionEmpresaDetalle.vue'),
                props: true,
            },
            {
                path: 'facturacion/empresa/:empresaId/servicios',
                name: 'admin.suscripciones.facturacion.empresa.servicios',
                component: () => import('@/views/admin/suscripciones/facturacion/EmpresaServiciosContratados.vue'),
                props: true,
            },
            {
                path: 'facturacion/resumen/:resumenId',
                name: 'admin.suscripciones.facturacion.resumen',
                component: () => import('@/views/admin/suscripciones/facturacion/ResumenDetalle.vue'),
                props: true,
            },
            {
                path: 'servicios',
                name: 'admin.suscripciones.servicios',
                component: () => import('@/views/admin/suscripciones/facturacion/ServiciosLista.vue'),
            },
            {
                path: 'solicitudes',
                name: 'admin.suscripciones.solicitudes',
                component: () => import('@/views/admin/suscripciones/SolicitudesLista.vue'),
            },
        ],
    },

    {
        path: 'soporte',
        name: 'configuracionsistema',
        component: () => import('@/views/admin/soporte/SoporteHome.vue'),
        children: [
            {
                path: 'condicionesIva',
                name: 'condicionesIva',
                component: () => import('@/views/empresa/soporte/CondicionesIva.vue'),
            },
            {
                path: 'estados',
                name: 'estados',
                component: () => import('@/views/empresa/soporte/EstadoPedidosSoporte.vue'),

            },
            {
                path: 'formasDePago',
                name: 'formasDePago',
                component: () => import('@/views/empresa/soporte/FormasDePagoSoporte.vue'),
            },
            {
                path: 'tipoNotificaciones',
                name: 'tipoNotificaciones',
                component: () => import('@/views/empresa/soporte/TipoDeNotificacionesSoporte.vue'),

            },
            {
                path: 'plazoVencimiento',
                name: 'plazoVencimiento',
                component: () => import('@/views/empresa/soporte/PlazoVencimientoSoporte.vue'),

            },
            {
                path: 'unidadMedida',
                name: 'unidadMedida',

                component: () => import('@/views/empresa/soporte/UnidadMedidaSoporte.vue'),

            },
            {
                path: 'motivoCambio',
                name: 'motivoCambio',

                component: () => import('@/views/empresa/soporte/MotivoCambioSoporte.vue'),

            },
            {
                path: 'recargo',
                name: 'recargo',

                component: () => import('@/views/empresa/soporte/RecargoSoporte.vue'),

            },
        ]
    },
    {
        path: '*',
        name: 'AdminNotFound',
        component: () => import('@/views/admin/NotFound.vue'),
    },


]
